import { Button, Input, ButtonProps, InputProps, Tooltip } from 'antd';
import { SearchOutlined, InfoOutlined } from '@ant-design/icons';
import './styles.less';
import InputDecimal from '../InputDecimal';

type Props = {
  inputProps?: InputProps;
  buttonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
  inputDecimal?: boolean;
  viewIcon?: boolean;
  valueMax?: number;
  disabledInputDecimal?: boolean;
};

const InputSearch: React.FC<Props> = ({
  inputProps,
  buttonProps,
  secondaryButtonProps,
  inputDecimal,
  viewIcon,
  valueMax,
  disabledInputDecimal,
  ...props
}) => {
  return (
    <div className="input-search">
      {!inputDecimal ? (
        <Input {...inputProps} {...props} />
      ) : (
        <InputDecimal
          max={valueMax}
          disabled={disabledInputDecimal}
          {...props}
        />
      )}

      <Button
        type="primary"
        icon={
          viewIcon ? (
            <InfoOutlined style={{ fontSize: 20 }} />
          ) : (
            <SearchOutlined style={{ fontSize: 20 }} />
          )
        }
        {...buttonProps}
      />

      {secondaryButtonProps && (
        <Tooltip title={secondaryButtonProps.title}>
          <Button type="default" {...secondaryButtonProps} />
        </Tooltip>
      )}
    </div>
  );
};

export default InputSearch;
